module.exports = __webpack_public_path__ + "ke.f45b49611c0f8a449cf1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ke.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ke.svg
// module chunks = styles